import { render, staticRenderFns } from "./DataInputSelect.vue?vue&type=template&id=219f400a&scoped=true&"
import script from "./DataInputSelect.vue?vue&type=script&lang=js&"
export * from "./DataInputSelect.vue?vue&type=script&lang=js&"
import style0 from "./DataInputSelect.vue?vue&type=style&index=0&id=219f400a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219f400a",
  null
  
)

export default component.exports